import { render } from "./TranslationsModal.vue?vue&type=template&id=50cc2552&scoped=true"
import script from "./TranslationsModal.vue?vue&type=script&lang=js"
export * from "./TranslationsModal.vue?vue&type=script&lang=js"

import "./TranslationsModal.vue?vue&type=style&index=0&id=50cc2552&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc2552"]])

export default __exports__